module.exports = __webpack_public_path__ + "static/media/undraw.6d01eec3.png";